import { Card, Tabs } from 'antd';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './AuthWrapper.style.less';
const { TabPane } = Tabs;

const AuthWrapper = ({ children }) => {
  const [current, setCurrent] = useState('signin');
  const location = useLocation();
  const navigate = useNavigate();

  const [hasMenu, setHasMenu] = useState(false);

  useEffect(() => {
    if (
      location.pathname.includes('/signin') ||
      location.pathname.includes('/signup')
    ) {
      // setHasMenu(true);
      if (location.pathname.includes('/signup')) {
        setCurrent('signup');
      } else setCurrent('signin');
    }
  }, [location.pathname]);

  const handleTabChange = (key) => {
    setCurrent(key);
    navigate('/' + key);
  };

  return (
    <div className='auth-wrap app-header-hor-header-fixed' key={'wrap'}>
      <div className='auth-banner'>
        <div className='welcome'>WELCOME</div>
        <div className='slogan'>
          Join the biggest mentor and mentee community in Singapore
        </div>
      </div>
      <Card className='auth-card'>
        <div className='auth-main-content'>
          <div className='auth-card-header'>
            {hasMenu && (
              <Tabs
                defaultActiveKey={current}
                onChange={handleTabChange}
                centered>
                <TabPane tab='LOG IN' key='signin'></TabPane>
                <TabPane tab='SIGN UP' key='signup'></TabPane>
              </Tabs>
            )}
          </div>
          {children}
        </div>
      </Card>
    </div>
  );
};

export default AuthWrapper;

AuthWrapper.propTypes = {
  children: PropTypes.node,
};
